module.exports = __webpack_public_path__ + "static/media/ico-more.0aefd55f.svg";